(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-tree-select", [], factory);
	else if(typeof exports === 'object')
		exports["vue-tree-select"] = factory();
	else
		root["vue-tree-select"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 33);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.0' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(28)('wks');
var uid = __webpack_require__(31);
var Symbol = __webpack_require__(4).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(7)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(0);
var ctx = __webpack_require__(23);
var hide = __webpack_require__(9);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var IE8_DOM_DEFINE = __webpack_require__(50);
var toPrimitive = __webpack_require__(68);
var dP = Object.defineProperty;

exports.f = __webpack_require__(2) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(5);
var createDesc = __webpack_require__(16);
module.exports = __webpack_require__(2) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(12);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(62);
var enumBugKeys = __webpack_require__(25);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(28)('keys');
var uid = __webpack_require__(31);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(37);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(19);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(45);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var document = __webpack_require__(4).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(22);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(5).f;
var has = __webpack_require__(8);
var TAG = __webpack_require__(1)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(26);
var defined = __webpack_require__(12);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(18);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_select_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_select_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ccaf43c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_tree_select_vue__ = __webpack_require__(78);
function injectStyle (ssrContext) {
  __webpack_require__(75)
}
var normalizeComponent = __webpack_require__(77)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_select_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ccaf43c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_tree_select_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _treeSelect = __webpack_require__(32);

var _treeSelect2 = _interopRequireDefault(_treeSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _treeSelect2.default;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var nodeList = [];
var ctx = '@@clickoutsideContext';

var startClick = void 0;

document.addEventListener('mousedown', function (e) {
  return startClick = e;
});
document.addEventListener('mouseup', function (e) {
  nodeList.forEach(function (node) {
    return node[ctx].documentHandler(e, startClick);
  });
});

/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */
exports.default = {
  bind: function bind(el, binding, vnode) {
    var id = nodeList.push(el) - 1;
    var documentHandler = function documentHandler() {
      var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;

      if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
        vnode.context[el[ctx].methodName]();
      } else {
        el[ctx].bindingFn && el[ctx].bindingFn();
      }
    };
    el[ctx] = {
      id: id,
      documentHandler: documentHandler,
      methodName: binding.expression,
      bindingFn: binding.value
    };
  },
  update: function update(el, binding) {
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = binding.value;
  },
  unbind: function unbind(el) {
    var len = nodeList.length;

    for (var i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }
  }
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UNSELECTABLE_ATTRIBUTE = exports.UNSELECTABLE_STYLE = undefined;

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(20);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(21);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _from = __webpack_require__(19);

var _from2 = _interopRequireDefault(_from);

var _extends2 = __webpack_require__(39);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(38);

var _keys2 = _interopRequireDefault(_keys);

exports.getValuePropValue = getValuePropValue;
exports.getPropValue = getPropValue;
exports.isCombobox = isCombobox;
exports.isMultipleOrTags = isMultipleOrTags;
exports.isMultipleOrTagsOrCombobox = isMultipleOrTagsOrCombobox;
exports.isSingleMode = isSingleMode;
exports.toArray = toArray;
exports.preventDefaultEvent = preventDefaultEvent;
exports.labelCompatible = labelCompatible;
exports.isInclude = isInclude;
exports.loopAllChildren = loopAllChildren;
exports.flatToHierarchy = flatToHierarchy;
exports.filterParentPosition = filterParentPosition;
exports.handleCheckState = handleCheckState;
exports.getTreeNodesStates = getTreeNodesStates;
exports.recursiveCloneChildren = recursiveCloneChildren;
exports.filterAllCheckedData = filterAllCheckedData;
exports.processSimpleTreeData = processSimpleTreeData;
exports.deepCopyArray = deepCopyArray;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
// import React from 'react'

function getValuePropValue(child) {
    var props = child.props;
    if ('value' in props) {
        return props.value;
    }
    if (child.key) {
        return child.key;
    }
    throw new Error('no key or value for ' + child);
}

function getPropValue(child, prop) {
    if (prop === 'value') {
        return getValuePropValue(child);
    }
    return child.props[prop];
}

function isCombobox(props) {
    return props.combobox;
}

function isMultipleOrTags(props) {
    return !!(props.multiple || props.tags || props.treeCheckable);
}

function isMultipleOrTagsOrCombobox(props) {
    return isMultipleOrTags(props) || isCombobox(props);
}

function isSingleMode(props) {
    return !isMultipleOrTagsOrCombobox(props);
}

function toArray(value) {
    var ret = value;
    if (value === undefined) {
        ret = [];
    } else if (!Array.isArray(value)) {
        ret = [value];
    }
    return ret;
}

function preventDefaultEvent(e) {
    e.preventDefault();
}

var UNSELECTABLE_STYLE = exports.UNSELECTABLE_STYLE = {
    userSelect: 'none',
    WebkitUserSelect: 'none'
};

var UNSELECTABLE_ATTRIBUTE = exports.UNSELECTABLE_ATTRIBUTE = {
    unselectable: 'unselectable'
};

function labelCompatible(prop) {
    var newProp = prop;
    if (newProp === 'label') {
        newProp = 'title';
    }
    return newProp;
}

function isInclude(smallArray, bigArray) {
    // attention: [0,0,1] [0,0,10]
    return smallArray.every(function (ii, i) {
        return ii === bigArray[i];
    });
}

/*
export function getCheckedKeys(node, checkedKeys, allCheckedNodesKeys) {
  const nodeKey = node.props.eventKey;
  let newCks = [...checkedKeys];
  let nodePos;
  const unCheck = allCheckedNodesKeys.some(item => {
    if (item.key === nodeKey) {
      nodePos = item.pos;
      return true;
    }
  });
  if (unCheck) {
    const nArr = nodePos.split('-');
    newCks = [];
    allCheckedNodesKeys.forEach(item => {
      const iArr = item.pos.split('-');
      if (item.pos === nodePos ||
        nArr.length > iArr.length && isInclude(iArr, nArr) ||
        nArr.length < iArr.length && isInclude(nArr, iArr)) {
        return;
      }
      newCks.push(item.key);
    });
  } else {
    newCks.push(nodeKey);
  }
  return newCks;
}
*/

function getChildrenlength(children) {
    var len = 1;
    if (Array.isArray(children)) {
        len = children.length;
    }
    return len;
}

function getSiblingPosition(index, len, siblingPosition) {
    if (len === 1) {
        siblingPosition.first = true;
        siblingPosition.last = true;
    } else {
        siblingPosition.first = index === 0;
        siblingPosition.last = index === len - 1;
    }
    return siblingPosition;
}

// export function loopAllChildren (childs, callback, parent) {
//   const loop = (children, level, _parent) => {
//     const len = getChildrenlength(children)
//     React.Children.forEach(children, function handler(item, index) { // eslint-disable-line
//       const pos = `${level}-${index}`
//       if (item && item.props.children && item.type) {
//         loop(item.props.children, pos, { node: item, pos })
//       }
//       if (item) {
//         callback(item, index, pos, item.key || pos, getSiblingPosition(index, len, {}), _parent)
//       }
//     })
//   }
//   loop(childs, 0, parent)
// }
function loopAllChildren(data, callback) {
    var loop = function loop(children, level) {
        children.forEach(function (item, index) {
            var pos = level + '-' + index;
            if (item && item.children) {
                loop(item.children, pos);
            }
            if (item) {
                callback(item, index, pos);
            }
        });
    };
    loop(data, 0);
}
// export function loopAllChildren(childs, callback) {
//   const loop = (children, level) => {
//     React.Children.forEach(children, (item, index) => {
//       const pos = `${level}-${index}`;
//       if (item && item.props.children) {
//         loop(item.props.children, pos);
//       }
//       if (item) {
//         callback(item, index, pos, getValuePropValue(item));
//       }
//     });
//   };
//   loop(childs, 0);
// }

function flatToHierarchy(arr) {
    if (!arr.length) {
        return arr;
    }
    var hierarchyNodes = [];
    var levelObj = {};
    arr.forEach(function (item) {
        if (!item.pos) {
            return;
        }
        var posLen = item.pos.split('-').length;
        if (!levelObj[posLen]) {
            levelObj[posLen] = [];
        }
        levelObj[posLen].push(item);
    });
    var levelArr = (0, _keys2.default)(levelObj).sort(function (a, b) {
        return b - a;
    });
    // const s = Date.now();
    // todo: there are performance issues!
    levelArr.reduce(function (pre, cur) {
        if (cur && cur !== pre) {
            levelObj[pre].forEach(function (item) {
                var haveParent = false;
                levelObj[cur].forEach(function (ii) {
                    if (isInclude(ii.pos.split('-'), item.pos.split('-'))) {
                        haveParent = true;
                        if (!ii.children) {
                            ii.children = [];
                        }
                        ii.children.push(item);
                    }
                });
                if (!haveParent) {
                    hierarchyNodes.push(item);
                }
            });
        }
        return cur;
    });
    // console.log(Date.now() - s);
    return levelObj[levelArr[levelArr.length - 1]].concat(hierarchyNodes);
}

// arr.length === 628, use time: ~20ms
function filterParentPosition(arr) {
    var levelObj = {};
    arr.forEach(function (item) {
        var posLen = item.split('-').length;
        if (!levelObj[posLen]) {
            levelObj[posLen] = [];
        }
        levelObj[posLen].push(item);
    });
    var levelArr = (0, _keys2.default)(levelObj).sort();

    var _loop = function _loop(i) {
        if (levelArr[i + 1]) {
            levelObj[levelArr[i]].forEach(function (ii) {
                var _loop2 = function _loop2(j) {
                    levelObj[levelArr[j]].forEach(function (_i, index) {
                        if (isInclude(ii.split('-'), _i.split('-'))) {
                            levelObj[levelArr[j]][index] = null;
                        }
                    });
                    levelObj[levelArr[j]] = levelObj[levelArr[j]].filter(function (p) {
                        return p;
                    });
                };

                for (var j = i + 1; j < levelArr.length; j++) {
                    _loop2(j);
                }
            });
        }
    };

    for (var i = 0; i < levelArr.length; i++) {
        _loop(i);
    }
    var nArr = [];
    levelArr.forEach(function (i) {
        nArr = nArr.concat(levelObj[i]);
    });
    return nArr;
}
// console.log(filterParentPosition(
// ['0-2', '0-3-3', '0-10', '0-10-0', '0-0-1', '0-0', '0-1-1', '0-1']
// ));

function stripTail(str) {
    var arr = str.match(/(.+)(-[^-]+)$/);
    var st = '';
    if (arr && arr.length === 3) {
        st = arr[1];
    }
    return st;
}
function splitPosition(pos) {
    return pos.split('-');
}

// todo: do optimization.
function handleCheckState(obj, checkedPositionArr, checkIt) {
    // console.log(stripTail('0-101-000'));
    // let s = Date.now();
    var objKeys = (0, _keys2.default)(obj);

    objKeys.forEach(function (i, index) {
        var iArr = splitPosition(i);
        var saved = false;
        checkedPositionArr.forEach(function (_pos) {
            var _posArr = splitPosition(_pos);
            if (iArr.length > _posArr.length && isInclude(_posArr, iArr)) {
                obj[i].halfChecked = false;
                obj[i].checked = checkIt;
                objKeys[index] = null;
            }
            if (iArr[0] === _posArr[0] && iArr[1] === _posArr[1]) {
                saved = true;
            }
        });
        if (!saved) {
            objKeys[index] = null;
        }
    });
    objKeys = objKeys.filter(function (i) {
        return i;
    }); // filter non null;

    var _loop3 = function _loop3(_pIndex) {
        // loop to set ancestral nodes's `checked` or `halfChecked`
        var loop = function loop(__pos) {
            var _posLen = splitPosition(__pos).length;
            if (_posLen <= 2) {
                // e.g. '0-0', '0-1'
                return;
            }
            var sibling = 0;
            var siblingChecked = 0;
            var parentPosition = stripTail(__pos);
            objKeys.forEach(function (i /* , index */) {
                var iArr = splitPosition(i);
                if (iArr.length === _posLen && isInclude(splitPosition(parentPosition), iArr)) {
                    sibling++;
                    if (obj[i].checked) {
                        siblingChecked++;
                        var _i = checkedPositionArr.indexOf(i);
                        if (_i > -1) {
                            checkedPositionArr.splice(_i, 1);
                            if (_i <= _pIndex) {
                                _pIndex--;
                            }
                        }
                    } else if (obj[i].halfChecked) {
                        siblingChecked += 0.5;
                    }
                    // objKeys[index] = null;
                }
            });
            // objKeys = objKeys.filter(i => i); // filter non null;
            var parent = obj[parentPosition];
            // not check, checked, halfChecked
            if (siblingChecked === 0) {
                parent.checked = false;
                parent.halfChecked = false;
            } else if (siblingChecked === sibling) {
                parent.checked = true;
                parent.halfChecked = false;
            } else {
                parent.halfChecked = true;
                parent.checked = false;
            }
            loop(parentPosition);
        };
        loop(checkedPositionArr[_pIndex], _pIndex);
        pIndex = _pIndex;
    };

    for (var pIndex = 0; pIndex < checkedPositionArr.length; pIndex++) {
        _loop3(pIndex);
    }
    // console.log(Date.now()-s, objKeys.length, checkIt);
}

function getCheck(treeNodesStates, checkedPositions) {
    var halfCheckedKeys = [];
    var checkedKeys = [];
    var checkedNodes = [];
    (0, _keys2.default)(treeNodesStates).forEach(function (item) {
        var itemObj = treeNodesStates[item];
        if (itemObj.checked) {
            checkedKeys.push(itemObj.key);
            // checkedNodes.push(getValuePropValue(itemObj.node));
            checkedNodes.push((0, _extends3.default)({}, itemObj, { pos: item }));
        } else if (itemObj.halfChecked) {
            halfCheckedKeys.push(itemObj.key);
        }
    });
    return {
        halfCheckedKeys: halfCheckedKeys, checkedKeys: checkedKeys, checkedNodes: checkedNodes, treeNodesStates: treeNodesStates, checkedPositions: checkedPositions
    };
}

function getTreeNodesStates(children, values) {
    var checkedPositions = [];
    var treeNodesStates = {};
    loopAllChildren(children, function (item, index, pos, keyOrPos, siblingPosition) {
        treeNodesStates[pos] = {
            node: item,
            key: keyOrPos,
            checked: false,
            halfChecked: false,
            siblingPosition: siblingPosition
        };
        if (values.indexOf(getValuePropValue(item)) !== -1) {
            treeNodesStates[pos].checked = true;
            checkedPositions.push(pos);
        }
    });

    handleCheckState(treeNodesStates, filterParentPosition(checkedPositions.sort()), true);

    return getCheck(treeNodesStates, checkedPositions);
}

// can add extra prop to every node.
function recursiveCloneChildren(children) {
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (ch) {
        return ch;
    };

    // return React.Children.map(children, child => {
    return (0, _from2.default)(children).map(function (child) {
        var newChild = cb(child);
        if (newChild && newChild.props && newChild.props.children) {
            return React.cloneElement(newChild, {}, recursiveCloneChildren(newChild.props.children, cb));
        }
        return newChild;
    });
}
// const newChildren = recursiveCloneChildren(children, child => {
//   const extraProps = {};
//   if (child && child.type && child.type.xxx) {
//     extraProps._prop = true;
//     return React.cloneElement(child, extraProps);
//   }
//   return child;
// });

function recursiveGen(children) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return React.Children.map(children, function (child, index) {
        var pos = level + '-' + index;
        var o = {
            title: child.props.title,
            label: child.props.label || child.props.title,
            value: child.props.value,
            key: child.key,
            _pos: pos
        };
        if (child.props.children) {
            o.children = recursiveGen(child.props.children, pos);
        }
        return o;
    });
}

function recursive(children, cb) {
    children.forEach(function (item) {
        cb(item);
        if (item.children) {
            recursive(item.children, cb);
        }
    });
}

// Get the tree's checkedNodes (todo: can merge to the `handleCheckState` function)
// If one node checked, it's all children nodes checked.
// If sibling nodes all checked, the parent checked.
function filterAllCheckedData(vs, treeNodes) {
    var vals = [].concat((0, _toConsumableArray3.default)(vs));
    if (!vals.length) {
        return vals;
    }

    var data = recursiveGen(treeNodes);
    var checkedNodesPositions = [];

    function checkChildren(children) {
        children.forEach(function (item) {
            if (item.__checked) {
                return;
            }
            var ci = vals.indexOf(item.value);
            var childs = item.children;
            if (ci > -1) {
                item.__checked = true;
                checkedNodesPositions.push({ node: item, pos: item._pos });
                vals.splice(ci, 1);
                if (childs) {
                    recursive(childs, function (child) {
                        child.__checked = true;
                        checkedNodesPositions.push({ node: child, pos: child._pos });
                    });
                }
            } else {
                if (childs) {
                    checkChildren(childs);
                }
            }
        });
    }

    function checkParent(children) {
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { root: true };

        var siblingChecked = 0;
        children.forEach(function (item) {
            var childs = item.children;
            if (childs && !item.__checked && !item.__halfChecked) {
                var p = checkParent(childs, item);
                if (p.__checked) {
                    siblingChecked++;
                } else if (p.__halfChecked) {
                    siblingChecked += 0.5;
                }
            } else if (item.__checked) {
                siblingChecked++;
            } else if (item.__halfChecked) {
                siblingChecked += 0.5;
            }
        });
        var len = children.length;
        if (siblingChecked === len) {
            parent.__checked = true;
            checkedNodesPositions.push({ node: parent, pos: parent._pos });
        } else if (siblingChecked < len && siblingChecked > 0) {
            parent.__halfChecked = true;
        }
        if (parent.root) {
            return children;
        }
        return parent;
    }
    checkChildren(data);
    checkParent(data);

    checkedNodesPositions.forEach(function (i, index) {
        // clear private metadata
        delete checkedNodesPositions[index].node.__checked;
        delete checkedNodesPositions[index].node._pos;
        // create the same structure of `onCheck`'s return.
        checkedNodesPositions[index].node.props = {
            title: checkedNodesPositions[index].node.title,
            label: checkedNodesPositions[index].node.label || checkedNodesPositions[index].node.title,
            value: checkedNodesPositions[index].node.value
        };
        if (checkedNodesPositions[index].node.children) {
            checkedNodesPositions[index].node.props.children = checkedNodesPositions[index].node.children;
        }
        delete checkedNodesPositions[index].node.title;
        delete checkedNodesPositions[index].node.label;
        delete checkedNodesPositions[index].node.value;
        delete checkedNodesPositions[index].node.children;
    });
    return checkedNodesPositions;
}

function processSimpleTreeData(treeData, format) {
    function unflatten2(array) {
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _defineProperty3.default)({}, format.id, format.rootPId);

        var children = [];
        for (var i = 0; i < array.length; i++) {
            array[i] = (0, _extends3.default)({}, array[i]); // copy, can not corrupts original data
            if (array[i][format.pId] === parent[format.id]) {
                array[i].key = array[i][format.id];
                children.push(array[i]);
                array.splice(i--, 1);
            }
        }
        if (children.length) {
            parent.children = children;
            children.forEach(function (child) {
                return unflatten2(array, child);
            });
        }
        if (parent[format.id] === format.rootPId) {
            return children;
        }
    }
    return unflatten2(treeData);
}

function deepCopyArray(array) {
    var ret = [];
    array.forEach(function (item) {
        var obj = {};
        obj = (0, _assign2.default)({}, item);
        if (item.children) {
            obj.children = deepCopyArray(item.children);
        }
        ret.push(obj);
    });
    return ret;
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(21);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(20);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classnames2 = __webpack_require__(40);

var _classnames3 = _interopRequireDefault(_classnames2);

var _vTree = __webpack_require__(76);

var _vTree2 = _interopRequireDefault(_vTree);

var _util = __webpack_require__(35);

var _clickoutside = __webpack_require__(34);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function filterFn(input, child) {
  return child.title.indexOf(input) > -1;
}

exports.default = {
  components: {
    tree: _vTree2.default
  },
  directives: {
    clickoutside: _clickoutside2.default
  },
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: [String, Array]
    },
    prefixCls: {
      type: String,
      default: 'v-tree-select'
    },
    placeholder: {
      type: String,
      default: '请下拉选择'
    },
    searchPlaceholder: {
      type: String,
      default: '请输入搜索'
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelInValue: { // 是否把每个选项的 label 包装到 value 中，会把 value 类型从 string 变为 {key: string, label: ReactNode, halfChecked(treeCheckStrictly 时有效): string[] } 的格式
      type: Boolean,
      default: false
    },
    filterTreeNode: {
      type: Function,
      default: filterFn
    },
    notFoundContent: {
      type: String,
      default: '抱歉,沒有找到!'
    }
  },
  data: function data() {
    return {
      value$: this.addLabelToValue(this.value),
      inputValue: '',
      open: false,
      focused: false,
      inputRefWidth: 0,
      defaultExpandedKeys: [],
      treedataList: [],
      treedata: (0, _util.deepCopyArray)(this.data)
    };
  },

  computed: {
    rootCls: function rootCls() {
      var _classnames;

      return (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, this.prefixCls, true), (0, _defineProperty3.default)(_classnames, this.prefixCls + '-open', this.open), (0, _defineProperty3.default)(_classnames, this.prefixCls + '-focused', this.open || this.focused), (0, _defineProperty3.default)(_classnames, this.prefixCls + '-disabled', this.disabled), (0, _defineProperty3.default)(_classnames, this.prefixCls + '-enabled', !this.disabled), (0, _defineProperty3.default)(_classnames, this.prefixCls + '-allow-clear', !!this.allowClear), _classnames));
    },
    dropdowmCls: function dropdowmCls() {
      var dropdownPrefixCls = this.prefixCls + '-dropdown';
      return (0, _classnames3.default)(dropdownPrefixCls, dropdownPrefixCls + '--' + (this.multiple ? 'multiple' : 'single'));
    },
    defaultSelectedKeys: function defaultSelectedKeys() {
      return (0, _util.toArray)(this.value);
    }
  },
  watch: {
    inputValue: function inputValue(newValue, oldValue) {
      this.inputRefWidth = this.$refs.inputRef.scrollWidth;
    },
    value: function value(newVal) {
      this.value$ = this.addLabelToValue((0, _util.toArray)(newVal));
    },
    data: function data(newVal) {
      this.treedata = (0, _util.deepCopyArray)(newVal);
    }
  },
  methods: {
    clickoutside: function clickoutside() {
      this.setOpenState(false);
    },
    addLabelToValue: function addLabelToValue(value) {
      var _this = this;

      value = value.map(function (v) {
        return {
          value: v,
          label: _this.getLabel(v)
        };
      });
      return value;
    },
    getLabel: function getLabel(value) {
      // 根据value获取label值
      var label = null;
      (0, _util.loopAllChildren)(this.data, function (item) {
        if (item.key === value) {
          label = item.title;
        }
      });
      return label;
    },
    onClearSelection: function onClearSelection() {
      if (this.disabled) {
        return;
      }
      if (this.inputValue || this.value.length) {
        this.fireChange([]);
        this.setOpenState(false);
        if (this.inputValue === null) {
          this.inputValue = '';
        }
      }
    },
    onInputChange: function onInputChange() {
      this.open = true;
      this.$emit('onSearch', this.inputValue);

      if (this.inputValue) {
        this.treedata = this.processTreeNode();
      } else {
        this.treedata = this.data;
      }
    },
    processTreeNode: function processTreeNode() {
      var _this2 = this;

      var data = (0, _util.deepCopyArray)(this.data);
      var filterPoss = [];
      this.defaultExpandedKeys = [];
      (0, _util.loopAllChildren)(data, function (child, index, pos) {
        if (_this2.filterTreeNode(_this2.inputValue, child)) {
          filterPoss.push(pos);
          _this2.defaultExpandedKeys.push(child.key);
        }
      });

      // Include the filtered nodes's ancestral nodes.
      var processedPoss = [];
      filterPoss.forEach(function (pos) {
        var arr = pos.split('-');
        arr.reduce(function (pre, cur) {
          var res = pre + '-' + cur;
          if (processedPoss.indexOf(res) < 0) {
            processedPoss.push(res);
          }
          return res;
        });
      });

      var filterNodesPositions = [];
      (0, _util.loopAllChildren)(data, function (child, index, pos) {
        if (processedPoss.indexOf(pos) > -1) {
          filterNodesPositions.push({ node: child, pos: pos });
        }
      });
      var hierarchyNodes = (0, _util.flatToHierarchy)(filterNodesPositions);
      var recursive = function recursive(children) {
        return children.map(function (child) {
          var children = void 0;
          if (child.children) {
            children = recursive(child.children);
          }
          return (0, _assign2.default)(child.node, { children: children });
        });
      };

      return recursive(hierarchyNodes);
    },
    onPlaceholderClick: function onPlaceholderClick() {
      this.$refs.inputRef.focus();
    },
    setOpenState: function setOpenState(open, needFocus) {
      var _this3 = this;

      var documentClickClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      this.open = open;
      this.$nextTick(function () {
        if (needFocus || open) {
          if (open || _this3.multiple) {
            var input = _this3.$refs.inputRef;
            if (input && document.activeElement !== input) {
              input.focus();
            }
          } else if (_this3.$refs.selection) {
            _this3.$refs.selection.focus();
          }
        }
      });
    },
    onSelect: function onSelect(selectedKeys, info) {
      if (info.selected === false) {
        this.onDeselect(info);
        return;
      }
      var item = info.node;
      var value = this.value$;

      var selectedValue = item.eventKey;
      var selectedLabel = item.title;
      var event = selectedValue;
      // TODO isLabelInValue
      this.$emit('onSelect', event, item, info);
      var checkEvt = info.event === 'check';

      if (this.multiple) {
        // 防重复
        if (value.some(function (i) {
          return i.value === selectedValue;
        })) {
          return;
        }
        value = value.concat([{
          value: selectedValue,
          label: selectedLabel
        }]);
      } else {
        if (value.length && value[0].value === selectedValue) {
          this.setOpenState(false);
          return;
        }
        value = [{
          value: selectedValue,
          label: selectedLabel
        }];
        this.setOpenState(false);
      }
      var extraInfo = {
        triggerValue: selectedValue,
        triggerNode: item
      };
      if (checkEvt) {} else {
        extraInfo.selected = info.selected;
      }

      this.fireChange(value, extraInfo);
      if (this.inputValue === null) {
        this.inputValue = '';
      }
    },
    onDeselect: function onDeselect(info) {
      this.removeSelected(info.node.eventKey);

      if (!this.multiple) {
        this.setOpenState(false);
      }
      if (this.inputValue === null) {
        this.inputValue = '';
      }
    },
    removeSelected: function removeSelected(selectedVal) {
      if (this.disabled) {
        return;
      }

      var label = void 0;
      var value = this.value$.filter(function (singleValue) {
        if (singleValue.value === selectedVal) {
          label = singleValue.label;
        }
        return singleValue.value !== selectedVal;
      });

      this.fireChange(value, { clear: true });
    },
    fireChange: function fireChange(value, extraInfo) {
      var vals = value.map(function (i) {
        return i.value;
      });
      var sv = this.value$.map(function (i) {
        return i.value;
      });
      if (vals.length !== sv.length || !vals.every(function (val, index) {
        return sv[index] === val;
      })) {
        var ex = { preValue: [].concat((0, _toConsumableArray3.default)(this.value$)) };
        if (extraInfo) {
          (0, _assign2.default)(ex, extraInfo);
        }
        var labs = null;
        var vls = value;
        if (!this.labelInValue) {
          labs = value.map(function (i) {
            return i.label;
          });
          vls = vls.map(function (v) {
            return v.value;
          });
        }

        this._savedValue = this.multiple ? vls : vls[0];
        this.$emit('input', this._savedValue);
        this.$emit('onChange', this._savedValue, labs, ex);
        // 以下代码用watch value代替
        // this.value$ = this.getValue(toArray(this._savedValue).map((v, i) => {
        //   return this.labelInValue ? v : {
        //     value: v,
        //     label: labs && labs[i]
        //   }
        // }))
      }
    },
    getValue: function getValue(val) {
      var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var value = val;

      return value;
    }
  },
  mounted: function mounted() {
    this.inputRefWidth = this.$refs.inputRef.scrollWidth;
  }
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(44), __esModule: true };

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74);
__webpack_require__(70);
module.exports = __webpack_require__(0).Array.from;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(71);
module.exports = __webpack_require__(0).Object.assign;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(72);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73);
module.exports = __webpack_require__(0).Object.keys;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(29);
var toLength = __webpack_require__(30);
var toAbsoluteIndex = __webpack_require__(67);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(22);
var TAG = __webpack_require__(1)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(5);
var createDesc = __webpack_require__(16);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(4).document;
module.exports = document && document.documentElement;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(2) && !__webpack_require__(7)(function () {
  return Object.defineProperty(__webpack_require__(24)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(14);
var ITERATOR = __webpack_require__(1)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(6);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(58);
var descriptor = __webpack_require__(16);
var setToStringTag = __webpack_require__(27);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(9)(IteratorPrototype, __webpack_require__(1)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(56);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(65);
var hide = __webpack_require__(9);
var has = __webpack_require__(8);
var Iterators = __webpack_require__(14);
var $iterCreate = __webpack_require__(53);
var setToStringTag = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(61);
var ITERATOR = __webpack_require__(1)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(1)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(15);
var gOPS = __webpack_require__(60);
var pIE = __webpack_require__(63);
var toObject = __webpack_require__(10);
var IObject = __webpack_require__(26);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(7)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(6);
var dPs = __webpack_require__(59);
var enumBugKeys = __webpack_require__(25);
var IE_PROTO = __webpack_require__(17)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(24)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(49).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(5);
var anObject = __webpack_require__(6);
var getKeys = __webpack_require__(15);

module.exports = __webpack_require__(2) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(8);
var toObject = __webpack_require__(10);
var IE_PROTO = __webpack_require__(17)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(8);
var toIObject = __webpack_require__(29);
var arrayIndexOf = __webpack_require__(46)(false);
var IE_PROTO = __webpack_require__(17)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(3);
var core = __webpack_require__(0);
var fails = __webpack_require__(7);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(9);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(18);
var defined = __webpack_require__(12);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(18);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(13);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(47);
var ITERATOR = __webpack_require__(1)('iterator');
var Iterators = __webpack_require__(14);
module.exports = __webpack_require__(0).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(23);
var $export = __webpack_require__(3);
var toObject = __webpack_require__(10);
var call = __webpack_require__(52);
var isArrayIter = __webpack_require__(51);
var toLength = __webpack_require__(30);
var createProperty = __webpack_require__(48);
var getIterFn = __webpack_require__(69);

$export($export.S + $export.F * !__webpack_require__(55)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(3);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(57) });


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(2), 'Object', { defineProperty: __webpack_require__(5).f });


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(10);
var $keys = __webpack_require__(15);

__webpack_require__(64)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(66)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(54)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("vue-tree",[],e):"object"==typeof exports?exports["vue-tree"]=e():t["vue-tree"]=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=45)}([function(t,e,n){var r=n(25)("wks"),o=n(17),i=n(2).Symbol,u="function"==typeof i;(t.exports=function(t){return r[t]||(r[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=r},function(t,e){var n=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=n)},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var r=n(11),o=n(34),i=n(27),u=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return u(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){t.exports=!n(8)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var r=n(35),o=n(19);t.exports=function(t){return r(o(t))}},function(t,e,n){var r=n(2),o=n(1),i=n(32),u=n(9),a=function(t,e,n){var s,c,f,l=t&a.F,d=t&a.G,p=t&a.S,h=t&a.P,y=t&a.B,v=t&a.W,x=d?o:o[e]||(o[e]={}),g=x.prototype,b=d?r:p?r[e]:(r[e]||{}).prototype;d&&(n=e);for(s in n)(c=!l&&b&&void 0!==b[s])&&s in x||(f=c?b[s]:n[s],x[s]=d&&"function"!=typeof b[s]?n[s]:y&&c?i(f,r):v&&b[s]==f?function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e.prototype=t.prototype,e}(f):h&&"function"==typeof f?i(Function.call,f):f,h&&((x.virtual||(x.virtual={}))[s]=f,t&a.R&&g&&!g[s]&&u(g,s,f)))};a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(3),o=n(13);t.exports=n(4)?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(39),o=n(20);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e,n){var r=n(14);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e){t.exports={}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,n){var r=n(19);t.exports=function(t){return Object(r(t))}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e){t.exports=!0},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){var r=n(3).f,o=n(5),i=n(0)("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e,n){var r=n(25)("keys"),o=n(17);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,e,n){var r=n(2),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e,n){var r=n(14);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){var r=n(2),o=n(1),i=n(21),u=n(29),a=n(3).f;t.exports=function(t){var e=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==t.charAt(0)||t in e||a(e,t,{value:u.f(t)})}},function(t,e,n){e.f=n(0)},function(t,e,n){"use strict";e.__esModule=!0;var r=n(51),o=function(t){return t&&t.__esModule?t:{default:t}}(r);e.default=function(t,e,n){return e in t?(0,o.default)(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}},function(t,e,n){var r,o;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
!function(){"use strict";function n(){for(var t=[],e=0;e<arguments.length;e++){var r=arguments[e];if(r){var o=typeof r;if("string"===o||"number"===o)t.push(r);else if(Array.isArray(r))t.push(n.apply(null,r));else if("object"===o)for(var u in r)i.call(r,u)&&r[u]&&t.push(u)}}return t.join(" ")}var i={}.hasOwnProperty;void 0!==t&&t.exports?t.exports=n:(r=[],void 0!==(o=function(){return n}.apply(e,r))&&(t.exports=o))}()},function(t,e,n){var r=n(63);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e,n){var r=n(14),o=n(2).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,e,n){t.exports=!n(4)&&!n(8)(function(){return 7!=Object.defineProperty(n(33)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(18);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e,n){"use strict";var r=n(21),o=n(7),i=n(40),u=n(9),a=n(5),s=n(12),c=n(73),f=n(23),l=n(82),d=n(0)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,e,n,y,v,x,g){c(n,e,y);var b,_,m,S=function(t){if(!p&&t in j)return j[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},O=e+" Iterator",w="values"==v,E=!1,j=t.prototype,C=j[d]||j["@@iterator"]||v&&j[v],K=C||S(v),M=v?w?S("entries"):K:void 0,P="Array"==e?j.entries||C:C;if(P&&(m=l(P.call(new t)))!==Object.prototype&&m.next&&(f(m,O,!0),r||a(m,d)||u(m,d,h)),w&&C&&"values"!==C.name&&(E=!0,K=function(){return C.call(this)}),r&&!g||!p&&!E&&j[d]||u(j,d,K),s[e]=K,s[O]=h,v)if(b={values:w?K:S("values"),keys:x?K:S("keys"),entries:M},g)for(_ in b)_ in j||i(j,_,b[_]);else o(o.P+o.F*(p||E),e,b);return b}},function(t,e,n){var r=n(11),o=n(79),i=n(20),u=n(24)("IE_PROTO"),a=function(){},s=function(){var t,e=n(33)("iframe"),r=i.length;for(e.style.display="none",n(69).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),s=t.F;r--;)delete s.prototype[i[r]];return s()};t.exports=Object.create||function(t,e){var n;return null!==t?(a.prototype=r(t),n=new a,a.prototype=null,n[u]=t):n=s(),void 0===e?n:o(n,e)}},function(t,e,n){var r=n(39),o=n(20).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,e,n){var r=n(5),o=n(6),i=n(65)(!1),u=n(24)("IE_PROTO");t.exports=function(t,e){var n,a=o(t),s=0,c=[];for(n in a)n!=u&&r(a,n)&&c.push(n);for(;e.length>s;)r(a,n=e[s++])&&(~i(c,n)||c.push(n));return c}},function(t,e,n){t.exports=n(9)},function(t,e,n){var r=n(26),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){"use strict";var r=n(84)(!0);n(36)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e){t.exports=function(t,e,n,r,o){var i,u=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(i=t,u=t.default);var s="function"==typeof u?u.options:u;e&&(s.render=e.render,s.staticRenderFns=e.staticRenderFns),r&&(s._scopeId=r);var c;if(o?(c=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),n&&n.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},s._ssrRegister=c):n&&(c=n),c){var f=s.functional,l=f?s.render:s.beforeCreate;f?s.render=function(t,e){return c.call(e),l(t,e)}:s.beforeCreate=l?[].concat(l,c):[c]}return{esModule:i,exports:u,options:s}}},function(t,e,n){function r(t){n(97)}var o=n(43)(n(47),n(99),r,null,null);t.exports=o.exports},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(44),o=function(t){return t&&t.__esModule?t:{default:t}}(r);e.default=o.default},function(t,e,n){"use strict";function r(t,e){!function t(n,r,o,i){Array.isArray(n)&&(n=n.filter(function(t){return!!t})),n.forEach(function(n,u){var a=r+"-"+u;o.push(a);var s=[];n.children&&t(n.children,a,s,a),e(n,u,a,n.key||a,s,i)})}(t,0,[])}function o(t,e){return t.every(function(t,n){return t===e[n]})}Object.defineProperty(e,"__esModule",{value:!0}),e.traverseTreeNodes=r,e.isInclude=o},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(50),i=r(o),u=n(55),a=r(u),s=n(52),c=r(s),f=n(30),l=r(f),d=n(98),p=r(d),h=n(31),y=r(h),v=n(46);e.default={name:"tree",components:{treeNode:p.default},props:{data:{type:Array,default:function(){return[]}},config:{type:Object,default:function(){return{title:"title",key:"key"}}},prefixCls:{type:String,default:"v-tree"},showLine:{type:Boolean,default:!1},showIcon:{type:Boolean,default:!1},selectable:{type:Boolean,default:!0},multiple:{type:Boolean,default:!1},checkable:{type:Boolean,default:!1},checkStrictly:{type:Boolean,default:!1},draggable:{type:Boolean,default:!1},autoExpandParent:{type:Boolean,default:!0},defaultExpandAll:{type:Boolean,default:!0},defaultExpandedKeys:{type:Array,default:function(){return[]}},expandedKeys:{type:Array,default:function(){return[]}},selectedKeys:{type:Array,default:function(){return[]}},defaultCheckedKeys:{type:Array,default:function(){return[]}},defaultSelectedKeys:{type:Array,default:function(){return[]}},loadData:{type:Function},titleRender:{type:Function}},data:function(){return{root:this,expandedKeys$:this.getDefaultExpandedKeys(),selectedKeys$:this.getDefaultSelectedKeys(),treeData:[]}},computed:{className:function(){return(0,y.default)(this.prefixCls,(0,l.default)({},this.prefixCls+"-show-line",this.showLine))}},watch:{data:function(t){this.treeData=this.loop(t)},expandedKeys$:function(t){this.treeData=this.loop(this.data)},selectedKeys$:function(t){this.treeData=this.loop(this.data)},expandedKeys:function(t){this.expandedKeys$=this.getDefaultExpandedKeys()},defaultExpandedKeys:function(){this.expandedKeys$=this.getDefaultExpandedKeys()},selectedKeys:function(t){this.selectedKeys$=this.getDefaultSelectedKeys()},defaultSelectedKeys:function(){this.selectedKeys$=this.getDefaultSelectedKeys()}},methods:{getFilterExpandedKeys:function(t,e,n){var r=t[e];if(!n&&!t.autoExpandParent)return r||[];var o=[];t.autoExpandParent&&(0,v.traverseTreeNodes)(this.data,function(t,e,n,i){r.indexOf(i)>-1&&o.push(n)});var i={};(0,v.traverseTreeNodes)(this.data,function(e,r,u,a){if(n)i[a]=!0;else if(t.autoExpandParent){var s=o.some(function(t){return(0,v.isInclude)(u.split("-"),t.split("-"))});s&&(i[a]=!0)}});var u=(0,c.default)(i);return u.length?u:r},getDefaultExpandedKeys:function(t){var e=this._props,n=t?void 0:this.getFilterExpandedKeys(e,"defaultExpandedKeys",!e.defaultExpandedKeys.length&&e.defaultExpandAll);return"expandedKeys"in e&&e.expandedKeys.length>0&&(n=(e.autoExpandParent?this.getFilterExpandedKeys(e,"expandedKeys",!1):e.expandedKeys)||[]),n},getDefaultSelectedKeys:function(t){var e=this,n=this._props,r=function(t){return e.multiple?[].concat((0,a.default)(t)):t.length?[t[0]]:t},o=t?void 0:r(this.defaultSelectedKeys);return"selectedKeys"in n&&n.selectedKeys.length>0&&(o=r(n.selectedKeys)),o},onExpand:function(t){var e=this,n=!t.expanded,r=this.expandedKeys.length>0,o=[].concat((0,a.default)(this.expandedKeys$)),i=o.indexOf(t.eventKey);if(n&&-1===i?o.push(t.eventKey):!n&&i>-1&&o.splice(i,1),r||(this.expandedKeys$=o),this.$emit("onExpand",o,{node:t,expanded:n}),n&&this.loadData)return this.loadData(t).then(function(){r||(e.expandedKeys$=o)})},onSelect:function(t){var e=this._props,n=[].concat((0,a.default)(this.selectedKeys$)),r=t.eventKey,o=n.indexOf(r),i=void 0;-1!==o?(i=!1,n.splice(o,1)):(i=!0,e.multiple||(n.length=0),n.push(r));var u=[];n.length&&(0,v.traverseTreeNodes)(this.data,function(t){-1!==n.indexOf(t.key)&&u.push(t)});var s={event:"select",node:t,selected:i,selectedNodes:u};this.selectedKeys.length>0||(this.selectedKeys$=n),this.$emit("onSelect",n,s)},onMouseEnter:function(t,e){this.$emit("onMouseEnter",{event:t,node:e})},onMouseLeave:function(t,e){this.$emit("onMouseLeave",{event:t,node:e})},onContextMenu:function(t,e){this.$emit("onRightClick",{event:t,node:e})},loop:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,r=[];return t.forEach(function(t,o){var u={},a=n+"-"+o,s=t.key||a;u=(0,i.default)({},t,{key:s,eventKey:s,root:e.root,pos:s,loadData:e.loadData,prefixCls:e.prefixCls,showIcon:e.showIcon,expanded:-1!==e.expandedKeys$.indexOf(s),selected:-1!==e.selectedKeys$.indexOf(s),titleRender:e.titleRender}),t.children&&(u.children=e.loop(t.children,a)),r.push(u)}),r}},created:function(){this.treeData=this.loop(this.data)}}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(56),i=r(o),u=n(30),a=r(u),s=n(31),c=r(s);e.default={name:"treeNode",components:{NodeContent:{render:function(t){var e=this.$parent;return e.root.titleRender?e.root.titleRender.call(e._renderProxy,t,{_self:e.root.$vnode.context,node:e}):t("span",{class:e.prefixCls+"-title"},[e.title])}}},props:{node:{type:Object,default:function(){return{}}},title:{type:String,default:"---"},pos:{type:String,default:""},eventKey:{type:String,default:""},showIcon:{type:Boolean,default:!0},loadData:{type:Function},prefixCls:{type:String,default:"v-tree"},disabled:{type:Boolean,default:!1},disableCheckbox:{type:Boolean,default:!0},expanded:{type:Boolean,default:!0},selected:{type:Boolean,default:!1},isLeaf:{type:Boolean,default:!0},root:{type:Object,default:function(){return{}}}},computed:{switcherCls:function(){var t=this.expanded?"open":"close";return(0,c.default)(this.prefixCls+"-switcher",this.prefixCls+"-switcher_"+t,(0,a.default)({},this.prefixCls+"-switcher-disabled",this.disabled))},cls:function(){return(0,c.default)(this.prefixCls+"-child-tree",(0,a.default)({},this.prefixCls+"-child-tree-open",this.expanded))},wrapCls:function(){var t=this.expanded?"open":"close",e=t;this.node.children&&0===this.node.children.length&&(this.loadData&&!this.isLeaf||(e="docu"));var n=this.prefixCls+"-node-content-wrapper",r=n+" "+n+"-"+(e===t?e:"normal")+" ";return this.disabled||(this.selected||!this._dropTrigger&&this.dragNodeHighlight)&&(r+=this.prefixCls+"-node-selected"),r},iconEleCls:function(){var t,e=this.expanded?"open":"close",n=e;0===this.node.children.length&&(this.loadData&&!this.isLeaf||(n="docu"));var r=(t={},(0,a.default)(t,this.prefixCls+"-iconEle",!0),(0,a.default)(t,this.prefixCls+"-icon_loading",this.dataLoading),(0,a.default)(t,this.prefixCls+"-icon__"+n,!0),t);return(0,c.default)(r)}},data:function(){return{dataLoading:!1}},methods:{onExpand:function(){var t=this,e=this.node.root.onExpand(this);e&&"object"===(void 0===e?"undefined":(0,i.default)(e))&&(this.dataLoading=!0,e.then(function(){t.dataLoading=!1},function(){t.dataLoading=!1}))},onSelect:function(){this.disabled||this.root.onSelect(this)},onMouseEnter:function(t){this.root.onMouseEnter(t,this)},onMouseLeave:function(t){this.root.onMouseLeave(t,this)},onContextMenu:function(t){this.root.onContextMenu(t,this)}}}},function(t,e,n){t.exports={default:n(57),__esModule:!0}},function(t,e,n){t.exports={default:n(58),__esModule:!0}},function(t,e,n){t.exports={default:n(59),__esModule:!0}},function(t,e,n){t.exports={default:n(60),__esModule:!0}},function(t,e,n){t.exports={default:n(61),__esModule:!0}},function(t,e,n){t.exports={default:n(62),__esModule:!0}},function(t,e,n){"use strict";e.__esModule=!0;var r=n(49),o=function(t){return t&&t.__esModule?t:{default:t}}(r);e.default=function(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return(0,o.default)(t)}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var o=n(54),i=r(o),u=n(53),a=r(u),s="function"==typeof a.default&&"symbol"==typeof i.default?function(t){return typeof t}:function(t){return t&&"function"==typeof a.default&&t.constructor===a.default&&t!==a.default.prototype?"symbol":typeof t};e.default="function"==typeof a.default&&"symbol"===s(i.default)?function(t){return void 0===t?"undefined":s(t)}:function(t){return t&&"function"==typeof a.default&&t.constructor===a.default&&t!==a.default.prototype?"symbol":void 0===t?"undefined":s(t)}},function(t,e,n){n(42),n(87),t.exports=n(1).Array.from},function(t,e,n){n(89),t.exports=n(1).Object.assign},function(t,e,n){n(90);var r=n(1).Object;t.exports=function(t,e,n){return r.defineProperty(t,e,n)}},function(t,e,n){n(91),t.exports=n(1).Object.keys},function(t,e,n){n(93),n(92),n(94),n(95),t.exports=n(1).Symbol},function(t,e,n){n(42),n(96),t.exports=n(29).f("iterator")},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports=function(){}},function(t,e,n){var r=n(6),o=n(41),i=n(85);t.exports=function(t){return function(e,n,u){var a,s=r(e),c=o(s.length),f=i(u,c);if(t&&n!=n){for(;c>f;)if((a=s[f++])!=a)return!0}else for(;c>f;f++)if((t||f in s)&&s[f]===n)return t||f||0;return!t&&-1}}},function(t,e,n){var r=n(18),o=n(0)("toStringTag"),i="Arguments"==r(function(){return arguments}()),u=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,a;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=u(e=Object(t),o))?n:i?r(e):"Object"==(a=r(e))&&"function"==typeof e.callee?"Arguments":a}},function(t,e,n){"use strict";var r=n(3),o=n(13);t.exports=function(t,e,n){e in t?r.f(t,e,o(0,n)):t[e]=n}},function(t,e,n){var r=n(10),o=n(22),i=n(15);t.exports=function(t){var e=r(t),n=o.f;if(n)for(var u,a=n(t),s=i.f,c=0;a.length>c;)s.call(t,u=a[c++])&&e.push(u);return e}},function(t,e,n){var r=n(2).document;t.exports=r&&r.documentElement},function(t,e,n){var r=n(12),o=n(0)("iterator"),i=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||i[o]===t)}},function(t,e,n){var r=n(18);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){var r=n(11);t.exports=function(t,e,n,o){try{return o?e(r(n)[0],n[1]):e(n)}catch(e){var i=t.return;throw void 0!==i&&r(i.call(t)),e}}},function(t,e,n){"use strict";var r=n(37),o=n(13),i=n(23),u={};n(9)(u,n(0)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(u,{next:o(1,n)}),i(t,e+" Iterator")}},function(t,e,n){var r=n(0)("iterator"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!o)return!1;var n=!1;try{var i=[7],u=i[r]();u.next=function(){return{done:n=!0}},i[r]=function(){return u},t(i)}catch(t){}return n}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var r=n(10),o=n(6);t.exports=function(t,e){for(var n,i=o(t),u=r(i),a=u.length,s=0;a>s;)if(i[n=u[s++]]===e)return n}},function(t,e,n){var r=n(17)("meta"),o=n(14),i=n(5),u=n(3).f,a=0,s=Object.isExtensible||function(){return!0},c=!n(8)(function(){return s(Object.preventExtensions({}))}),f=function(t){u(t,r,{value:{i:"O"+ ++a,w:{}}})},l=function(t,e){if(!o(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!i(t,r)){if(!s(t))return"F";if(!e)return"E";f(t)}return t[r].i},d=function(t,e){if(!i(t,r)){if(!s(t))return!0;if(!e)return!1;f(t)}return t[r].w},p=function(t){return c&&h.NEED&&s(t)&&!i(t,r)&&f(t),t},h=t.exports={KEY:r,NEED:!1,fastKey:l,getWeak:d,onFreeze:p}},function(t,e,n){"use strict";var r=n(10),o=n(22),i=n(15),u=n(16),a=n(35),s=Object.assign;t.exports=!s||n(8)(function(){var t={},e={},n=Symbol(),r="abcdefghijklmnopqrst";return t[n]=7,r.split("").forEach(function(t){e[t]=t}),7!=s({},t)[n]||Object.keys(s({},e)).join("")!=r})?function(t,e){for(var n=u(t),s=arguments.length,c=1,f=o.f,l=i.f;s>c;)for(var d,p=a(arguments[c++]),h=f?r(p).concat(f(p)):r(p),y=h.length,v=0;y>v;)l.call(p,d=h[v++])&&(n[d]=p[d]);return n}:s},function(t,e,n){var r=n(3),o=n(11),i=n(10);t.exports=n(4)?Object.defineProperties:function(t,e){o(t);for(var n,u=i(e),a=u.length,s=0;a>s;)r.f(t,n=u[s++],e[n]);return t}},function(t,e,n){var r=n(15),o=n(13),i=n(6),u=n(27),a=n(5),s=n(34),c=Object.getOwnPropertyDescriptor;e.f=n(4)?c:function(t,e){if(t=i(t),e=u(e,!0),s)try{return c(t,e)}catch(t){}if(a(t,e))return o(!r.f.call(t,e),t[e])}},function(t,e,n){var r=n(6),o=n(38).f,i={}.toString,u="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],a=function(t){try{return o(t)}catch(t){return u.slice()}};t.exports.f=function(t){return u&&"[object Window]"==i.call(t)?a(t):o(r(t))}},function(t,e,n){var r=n(5),o=n(16),i=n(24)("IE_PROTO"),u=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?u:null}},function(t,e,n){var r=n(7),o=n(1),i=n(8);t.exports=function(t,e){var n=(o.Object||{})[t]||Object[t],u={};u[t]=e(n),r(r.S+r.F*i(function(){n(1)}),"Object",u)}},function(t,e,n){var r=n(26),o=n(19);t.exports=function(t){return function(e,n){var i,u,a=String(o(e)),s=r(n),c=a.length;return s<0||s>=c?t?"":void 0:(i=a.charCodeAt(s),i<55296||i>56319||s+1===c||(u=a.charCodeAt(s+1))<56320||u>57343?t?a.charAt(s):i:t?a.slice(s,s+2):u-56320+(i-55296<<10)+65536)}}},function(t,e,n){var r=n(26),o=Math.max,i=Math.min;t.exports=function(t,e){return t=r(t),t<0?o(t+e,0):i(t,e)}},function(t,e,n){var r=n(66),o=n(0)("iterator"),i=n(12);t.exports=n(1).getIteratorMethod=function(t){if(void 0!=t)return t[o]||t["@@iterator"]||i[r(t)]}},function(t,e,n){"use strict";var r=n(32),o=n(7),i=n(16),u=n(72),a=n(70),s=n(41),c=n(67),f=n(86);o(o.S+o.F*!n(74)(function(t){Array.from(t)}),"Array",{from:function(t){var e,n,o,l,d=i(t),p="function"==typeof this?this:Array,h=arguments.length,y=h>1?arguments[1]:void 0,v=void 0!==y,x=0,g=f(d);if(v&&(y=r(y,h>2?arguments[2]:void 0,2)),void 0==g||p==Array&&a(g))for(e=s(d.length),n=new p(e);e>x;x++)c(n,x,v?y(d[x],x):d[x]);else for(l=g.call(d),n=new p;!(o=l.next()).done;x++)c(n,x,v?u(l,y,[o.value,x],!0):o.value);return n.length=x,n}})},function(t,e,n){"use strict";var r=n(64),o=n(75),i=n(12),u=n(6);t.exports=n(36)(Array,"Array",function(t,e){this._t=u(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,o(1)):"keys"==e?o(0,n):"values"==e?o(0,t[n]):o(0,[n,t[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(t,e,n){var r=n(7);r(r.S+r.F,"Object",{assign:n(78)})},function(t,e,n){var r=n(7);r(r.S+r.F*!n(4),"Object",{defineProperty:n(3).f})},function(t,e,n){var r=n(16),o=n(10);n(83)("keys",function(){return function(t){return o(r(t))}})},function(t,e){},function(t,e,n){"use strict";var r=n(2),o=n(5),i=n(4),u=n(7),a=n(40),s=n(77).KEY,c=n(8),f=n(25),l=n(23),d=n(17),p=n(0),h=n(29),y=n(28),v=n(76),x=n(68),g=n(71),b=n(11),_=n(6),m=n(27),S=n(13),O=n(37),w=n(81),E=n(80),j=n(3),C=n(10),K=E.f,M=j.f,P=w.f,L=r.Symbol,A=r.JSON,D=A&&A.stringify,k=p("_hidden"),T=p("toPrimitive"),N={}.propertyIsEnumerable,F=f("symbol-registry"),$=f("symbols"),I=f("op-symbols"),R=Object.prototype,B="function"==typeof L,G=r.QObject,V=!G||!G.prototype||!G.prototype.findChild,H=i&&c(function(){return 7!=O(M({},"a",{get:function(){return M(this,"a",{value:7}).a}})).a})?function(t,e,n){var r=K(R,e);r&&delete R[e],M(t,e,n),r&&t!==R&&M(R,e,r)}:M,W=function(t){var e=$[t]=O(L.prototype);return e._k=t,e},J=B&&"symbol"==typeof L.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof L},U=function(t,e,n){return t===R&&U(I,e,n),b(t),e=m(e,!0),b(n),o($,e)?(n.enumerable?(o(t,k)&&t[k][e]&&(t[k][e]=!1),n=O(n,{enumerable:S(0,!1)})):(o(t,k)||M(t,k,S(1,{})),t[k][e]=!0),H(t,e,n)):M(t,e,n)},q=function(t,e){b(t);for(var n,r=x(e=_(e)),o=0,i=r.length;i>o;)U(t,n=r[o++],e[n]);return t},z=function(t,e){return void 0===e?O(t):q(O(t),e)},X=function(t){var e=N.call(this,t=m(t,!0));return!(this===R&&o($,t)&&!o(I,t))&&(!(e||!o(this,t)||!o($,t)||o(this,k)&&this[k][t])||e)},Y=function(t,e){if(t=_(t),e=m(e,!0),t!==R||!o($,e)||o(I,e)){var n=K(t,e);return!n||!o($,e)||o(t,k)&&t[k][e]||(n.enumerable=!0),n}},Q=function(t){for(var e,n=P(_(t)),r=[],i=0;n.length>i;)o($,e=n[i++])||e==k||e==s||r.push(e);return r},Z=function(t){for(var e,n=t===R,r=P(n?I:_(t)),i=[],u=0;r.length>u;)!o($,e=r[u++])||n&&!o(R,e)||i.push($[e]);return i};B||(L=function(){if(this instanceof L)throw TypeError("Symbol is not a constructor!");var t=d(arguments.length>0?arguments[0]:void 0),e=function(n){this===R&&e.call(I,n),o(this,k)&&o(this[k],t)&&(this[k][t]=!1),H(this,t,S(1,n))};return i&&V&&H(R,t,{configurable:!0,set:e}),W(t)},a(L.prototype,"toString",function(){return this._k}),E.f=Y,j.f=U,n(38).f=w.f=Q,n(15).f=X,n(22).f=Z,i&&!n(21)&&a(R,"propertyIsEnumerable",X,!0),h.f=function(t){return W(p(t))}),u(u.G+u.W+u.F*!B,{Symbol:L});for(var tt="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),et=0;tt.length>et;)p(tt[et++]);for(var nt=C(p.store),rt=0;nt.length>rt;)y(nt[rt++]);u(u.S+u.F*!B,"Symbol",{for:function(t){return o(F,t+="")?F[t]:F[t]=L(t)},keyFor:function(t){if(J(t))return v(F,t);throw TypeError(t+" is not a symbol!")},useSetter:function(){V=!0},useSimple:function(){V=!1}}),u(u.S+u.F*!B,"Object",{create:z,defineProperty:U,defineProperties:q,getOwnPropertyDescriptor:Y,getOwnPropertyNames:Q,getOwnPropertySymbols:Z}),A&&u(u.S+u.F*(!B||c(function(){var t=L();return"[null]"!=D([t])||"{}"!=D({a:t})||"{}"!=D(Object(t))})),"JSON",{stringify:function(t){if(void 0!==t&&!J(t)){for(var e,n,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);return e=r[1],"function"==typeof e&&(n=e),!n&&g(e)||(e=function(t,e){if(n&&(e=n.call(this,t,e)),!J(e))return e}),r[1]=e,D.apply(A,r)}}}),L.prototype[T]||n(9)(L.prototype,T,L.prototype.valueOf),l(L,"Symbol"),l(Math,"Math",!0),l(r.JSON,"JSON",!0)},function(t,e,n){n(28)("asyncIterator")},function(t,e,n){n(28)("observable")},function(t,e,n){n(88);for(var r=n(2),o=n(9),i=n(12),u=n(0)("toStringTag"),a="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),s=0;s<a.length;s++){var c=a[s],f=r[c],l=f&&f.prototype;l&&!l[u]&&o(l,u,c),i[c]=i.Array}},function(t,e){},function(t,e,n){var r=n(43)(n(48),n(100),null,null,null);t.exports=r.exports},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("ul",{class:t.className,attrs:{role:"tree-node"}},t._l(t.treeData,function(t){return n("treeNode",{attrs:{node:t,title:t.title,pos:t.pos,showIcon:t.showIcon,loadData:t.loadData,prefixCls:t.prefixCls,expanded:t.expanded,selected:t.selected,eventKey:t.eventKey,root:t.root}})}))},staticRenderFns:[]}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("li",[t.node.children&&t.node.children.length>0?n("span",{class:t.switcherCls,on:{click:t.onExpand}}):n("span",{class:[this.prefixCls+"-switcher "+this.prefixCls+"-switcher-noop"]}),t._v(" "),this.showIcon||this.loadData&&this.dataLoading?n("span",{class:t.iconEleCls}):t._e(),t._v(" "),n("span",{ref:"selectHandle",class:t.wrapCls,attrs:{title:"string"==typeof this.title?this.title:""},on:{mouseenter:function(e){e.preventDefault(),t.onMouseEnter(e)},mouseleave:function(e){e.preventDefault(),t.onMouseLeave(e)},contextmenu:function(e){e.preventDefault(),t.onContextMenu(e)},click:function(e){e.preventDefault(),t.onSelect(e)}}},[n("span"),t._v(" "),n("node-content")],1),t._v(" "),t.expanded?n("ul",{class:t.cls,attrs:{"data-expanded":t.expanded}},t._l(t.node.children,function(t){return n("treeNode",{attrs:{node:t,title:t.title,pos:t.pos,showIcon:t.showIcon,loadData:t.loadData,prefixCls:t.prefixCls,expanded:t.expanded,selected:t.selected,eventKey:t.eventKey,root:t.root}})})):t._e()])},staticRenderFns:[]}}])});

/***/ }),
/* 77 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.clickoutside),
      expression: "clickoutside"
    }],
    staticStyle: {
      "position": "relative",
      "width": "300px"
    }
  }, [_c('span', {
    class: _vm.rootCls,
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.setOpenState(!_vm.open)
      }
    }
  }, [_c('span', {
    key: "selection",
    ref: "selection",
    class: (_vm.prefixCls + "-selection " + _vm.prefixCls + "-selection--" + (_vm.multiple ? 'multiple' : 'single'))
  }, [(!_vm.multiple) ? [_c('span', {
    class: (_vm.prefixCls + "-selection__rendered")
  }, [(_vm.value$.length) ? _c('span', {
    key: "value",
    class: (_vm.prefixCls + "-selection-selected-value"),
    attrs: {
      "title": _vm.value$[0].label
    }
  }, [_vm._v(_vm._s(_vm.value$[0].label))]) : _c('span', {
    key: "placeholder",
    class: (_vm.prefixCls + "-selection__placeholder")
  }, [_vm._v(_vm._s(_vm.placeholder))])])] : [_c('ul', {
    class: (_vm.prefixCls + "-selection__rendered")
  }, [_vm._l((_vm.value$), function(singleValue) {
    return _c('li', {
      key: singleValue.value,
      class: (_vm.prefixCls + "-selection__choice"),
      attrs: {
        "title": singleValue.label
      }
    }, [_c('span', {
      class: (_vm.prefixCls + "-selection__choice__remove"),
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.removeSelected(singleValue.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      class: (_vm.prefixCls + "-selection__choice__content")
    }, [_vm._v(_vm._s(singleValue.label))])])
  }), _vm._v(" "), _c('li', {
    key: "__input",
    class: (_vm.prefixCls + "-search " + _vm.prefixCls + "-search--inline")
  }, [_c('span', {
    class: (_vm.prefixCls + "-search__field__wrap")
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    ref: "inputRef",
    class: (_vm.prefixCls + "-search__field"),
    style: ({
      width: (_vm.inputRefWidth + "px")
    }),
    attrs: {
      "role": "textbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }, _vm.onInputChange]
    }
  })])])], 2)], _vm._v(" "), (_vm.allowClear && _vm.value$.length && _vm.value$[0].value) ? _c('span', {
    key: "clear",
    class: (_vm.prefixCls + "-selection__clear"),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onClearSelection($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    key: "arrow",
    class: (_vm.prefixCls + "-arrow"),
    staticStyle: {
      "outline": "'none'"
    }
  }, [_c('b')]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.multiple && (_vm.inputValue !== '' || !_vm.value$.length)),
      expression: "multiple && (inputValue!=='' || !value$.length)"
    }],
    class: (_vm.prefixCls + "-search__field__placeholder"),
    on: {
      "click": _vm.onPlaceholderClick
    }
  }, [_vm._v("\n        " + _vm._s(_vm.placeholder) + "\n      ")])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    class: _vm.dropdowmCls,
    staticStyle: {
      "max-height": "200px",
      "overflow": "auto"
    }
  }, [_c('div', [(!_vm.multiple) ? _c('span', {
    class: ((this.prefixCls) + "-dropdown-search")
  }, [_c('span', {
    class: (_vm.prefixCls + "-search__field__wrap")
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    ref: "inputRef",
    class: (_vm.prefixCls + "-search__field"),
    attrs: {
      "role": "textbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }, _vm.onInputChange]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.inputValue),
      expression: "!inputValue"
    }],
    class: (_vm.prefixCls + "-search__field__placeholder"),
    on: {
      "click": _vm.onPlaceholderClick
    }
  }, [_vm._v("\n            " + _vm._s(_vm.searchPlaceholder) + "\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.treedata.length) ? _c('tree', {
    attrs: {
      "multiple": _vm.multiple,
      "data": _vm.treedata,
      "defaultSelectedKeys": _vm.defaultSelectedKeys,
      "defaultExpandedKeys": _vm.defaultExpandedKeys
    },
    on: {
      "onSelect": _vm.onSelect
    }
  }) : _c('span', {
    class: (_vm.prefixCls + "-not-found")
  }, [_vm._v("\n        " + _vm._s(_vm.notFoundContent) + "\n      ")])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.min.js